// Polyfills for newer JS APIs used by pdfjs-dist v5+ that are missing
// in older browser engines (e.g. React Native WebView)

if (typeof URL !== 'undefined' && typeof URL.parse !== 'function') {
	URL.parse = function (url: string, base?: string | URL): URL | null {
		try {
			return new URL(url, base);
		} catch {
			return null;
		}
	};
}

if (typeof Promise.withResolvers !== 'function') {
	Promise.withResolvers = function <T>(): {
		promise: Promise<T>;
		resolve: (value: T | PromiseLike<T>) => void;
		reject: (reason?: unknown) => void;
	} {
		let resolve!: (value: T | PromiseLike<T>) => void;
		let reject!: (reason?: unknown) => void;
		const promise = new Promise<T>((res, rej) => {
			resolve = res;
			reject = rej;
		});
		return { promise, resolve, reject };
	};
}
